import React from 'react';

import type { FormFields } from '../types';

import { CONTRACT_LICENSES } from 'lib/contracts/licenses';
import FormFieldFancySelect from 'ui/shared/forms/fields/FormFieldFancySelect';

import ContractVerificationFormRow from '../ContractVerificationFormRow';

const options = CONTRACT_LICENSES.map(({ label, title, type }) => ({ label: `${ title } (${ label })`, value: type }));

const ContractVerificationFieldLicenseType = () => {

  return (
    <ContractVerificationFormRow>
      <FormFieldFancySelect<FormFields, 'license_type'>
        name="license_type"
        placeholder="Contract license"
        options={ options }
      />
    </ContractVerificationFormRow>
  );
};

export default React.memo(ContractVerificationFieldLicenseType);
